import {
    AbstractPmsApiService
} from "./abstract.service";
import {
    Item
} from "../models";

/**
 * @class ItemPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Item>}
 */
export class ItemPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/item(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Item}
     * @protected
     */
    newModel(attributes, ...params) {

        return new Item(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Item>>}
     */
    get(params = {}, property = null) {

        const url = this.url({
            propertyId: property ? property.id : 0
        });
        const ignoreLB = params.hasOwnProperty('searchValue');

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Item} item
     * @param {Property} property
     * @returns {Promise.<Item>}
     */
    create(item, property) {

        const url = this.url({
            propertyId: property.id
        });

        return this.http
            .post(url, item.toObjectExcept('property', 'item_category'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Item} item
     * @returns {Promise.<Item>}
     */
    update(item) {

        const url = this.url({
            propertyId: item.property.id,
            id: item.id
        });

        return this.http
            .put(url, item.toObjectExcept('property', 'item_category'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Item} item
     * @returns {Promise.<boolean>}
     */
    delete(item) {

        const url = this.url({
            propertyId: item.property.id,
            id: item.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    show(propertyId, itemId, params = {}) {

        const url = this.url({
            propertyId: propertyId,
            id: itemId
        });

      return this.http.get(url, {
            headers: this.authHeaders,
            params
        })
        .then(this.getModeler())
        .catch(this.getErrorHandler());
    }

    /**
     * @param {Item} item
     * @returns {Promise.<boolean>}
     */
    moveUp(item) {

        const url = this.url({
            propertyId: item.property.id,
            id: item.id
        });

        return this.http
            .get(url + '/up', {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Item} item
     * @returns {Promise.<boolean>}
     */
    moveDown(item) {

        const url = this.url({
            propertyId: item.property.id,
            id: item.id
        });

        return this.http
            .get(url + '/down', {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/item.service.js